import { h } from "preact";
import { Card } from 'antd';
import SettingItem from './SettingItem';
import CountrySelector from './CountrySelector';

const SettingsGroup = ({
                           group,
                           settings,
                           loading,
                           onToggle,
                           onSettingChange
                       }) => {
    // Check if this group depends on the master FPE switch
    const isDisabledByMaster = group.dependsOn && settings[group.dependsOn] === true;

    return (
        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>{group.icon}</span>
                    <span>{group.title}</span>
                    {isDisabledByMaster && (
                        <span style={{
                            fontSize: '12px',
                            color: '#ff4d4f',
                            fontWeight: 'normal',
                            marginLeft: '8px'
                        }}>
                            (Disabled by FPE Master Switch)
                        </span>
                    )}
                </div>
            }
            style={{
                marginBottom: '24px',
                opacity: isDisabledByMaster ? 0.6 : 1,
                transition: 'opacity 0.3s ease'
            }}
        >
            {group.settings.map(setting => (
                <SettingItem
                    key={setting.key}
                    title={setting.title}
                    description={setting.description}
                    settingKey={setting.key}
                    apiMethods={setting.apiMethods}
                    settings={settings}
                    loading={loading}
                    onToggle={onToggle}
                    disabled={isDisabledByMaster}
                    isMaster={setting.isMaster}
                    invertLogic={setting.invertLogic}
                >
                    {setting.hasChildren && setting.key === 'allowed_countries' && (
                        <CountrySelector
                            settings={settings}
                            onSettingChange={onSettingChange}
                            disabled={isDisabledByMaster}
                        />
                    )}
                </SettingItem>
            ))}
        </Card>
    );
};

export default SettingsGroup;